import React from "react";
import "./ShopTeaTime.css";
import hotCinnamon from "../assets/img/tea-time/hot-cinnamon-spice-tea.png";
import teaWare from "../assets/img/tea-time/winter-quality-teaware.png";
import gourmetFood from "../assets/img/tea-time/rosewood-honey-specialty.png";

function ShopTeaTime() {
  return (
    <div className="container my-3 tea-time-container">
      <div className="row d-flex justify-content-center">
        <div className="col-lg-4 col-md-12 d-flex justify-content-center">
          <div className="card card-shop-tea img-tea-time border-0">
            <img
              src={hotCinnamon}
              className="card-img-top img-fluid rounded-0"
              alt="hot cinnamon"
            />
            <div className="card-body px-0">
              <p className="card-title fs-7">HOT CINNAMON SPICE TEA</p>
              <p className="card-text m-0 fs-7 f-roboto">
                Shop our all-time best selling tea. It is an assertive blend of
                black teas, three types of cinnamon, orange peel, and sweet
                cloves. Also available in green tea, herbal and decaf versions.
              </p>
              <a
                href="#"
                className="btn btn-outline-yellow fs-8 rounded-0 mt-4"
              >
                SHOP HOT CINNAMON SPICE TEAS
              </a>
            </div>
          </div>
        </div>
        <div className="col-lg-4 col-md-12 d-flex justify-content-center">
          <div className="card card-shop-tea img-tea-time border-0">
            <img
              src={teaWare}
              className="card-img-top img-fluid rounded-0"
              alt="tea ware"
            />
            <div className="card-body px-0">
              <p className="card-title fs-7">TEAWARE</p>
              <p className="card-text m-0 fs-7 f-roboto">
                Explore our selection of teaware that unifies quality, and
                timeless design with simplicity and function so that you can
                enjoy a perfect cuppa every single time.
              </p>
              <a
                href="#"
                className="btn btn-outline-yellow fs-8 rounded-0 shop-teaware-btn"
              >
                SHOP TEAWARE
              </a>
            </div>
          </div>
        </div>
        <div className="col-lg-4 col-md-12 d-flex justify-content-center">
          <div className="card card-shop-tea img-tea-time border-0">
            <img
              src={gourmetFood}
              className="card-img-top img-fluid rounded-0"
              alt="gourmet food"
            />
            <div className="card-body">
              <p className="card-title fs-7">GOURMET FOOD</p>
              <p className="card-text m-0 fs-7 f-roboto">
                Explore our selection of Canadian specialty food that will
                perfectly complement your cup of tea. Raw honey from Niagara or
                handmade shortbread cookies, we're sure you will love them all.
              </p>
              <a
                href="#"
                className="btn btn-outline-yellow fs-8 rounded-0 mt-4"
              >
                SHOP GOURMET FOOD
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ShopTeaTime;
